import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaCoins } from "react-icons/fa";
import useTranslate from "../../hooks/useTranslate";
import GoogleTranslate from "../GoogleTranslate";

const Navbar = (props) => {
  const navigate = useNavigate();
  const currentLanguage = useTranslate();
  const userDetails = useSelector((state) => state.studentAuth);

  const [isAthena, setIsAthena] = useState(false);
  const [logoUrl, setLogoUrl] = useState("/images/logo.png");

  useEffect(() => {
    const athenaFlag = localStorage.getItem("fromAthena") === "true";
    setIsAthena(athenaFlag);

    if (athenaFlag) {
      const storedLogo = localStorage.getItem("companyPhotoUrl");

      if (storedLogo) {
        setLogoUrl(storedLogo);
      }
    }
  }, []);

  const goToProfile = () => {
    if (!isAthena) {
      navigate("/student/profile");
    }
  };

  return (
    <div className="border border-y-1 border-gray-400 bg-white w-full z-[9999] m-0 fixed top-0 h-[60px]">
      <div className="navbar flex justify-between items-center h-full px-4 overflow-hidden">
        <img
          src={logoUrl}
          alt="Logo"
          width="150"
          className="h-[40px] object-contain"
          onError={() => setLogoUrl("/images/logo.png")}
        />

        <div className="flex gap-4 items-center">
          <button
            className="border border-[#D9E1E7] rounded-md p-2 flex gap-3 items-center"
            onClick={goToProfile}
          >
            <img
              src={userDetails?.user?.avatar?.url}
              alt=""
              className="h-5 w-5 p-[2px] rounded"
            />
            <h2 className="text-sm font-bold font-dmSans">
              {userDetails?.user?.FirstName}
            </h2>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Navbar;
